import React from 'react';
import { useToast } from '../../context/ToastContext';
import styles from './ToastViewport.module.css';

function ToastViewport() {
  const { toasts, removeToast } = useToast();

  return (
    <div className={styles.viewport} aria-live="polite" aria-atomic="false">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`${styles.toast} ${styles[toast.type] || styles.info}`}
          role="status"
        >
          <span>{toast.message}</span>
          <button
            type="button"
            className={styles.dismiss}
            onClick={() => removeToast(toast.id)}
            aria-label="Dismiss notification"
          >
            x
          </button>
        </div>
      ))}
    </div>
  );
}

export default ToastViewport;
